Pixlee.module('Utilities', function(Entities, App, Backbone, Marionette, $) {
    App.commands.setHandler('when:fetched', function(entities, callback) {
        var xhrs;
        xhrs = _.chain([entities]).flatten().pluck('_fetch').value();
        return $.when.apply($, xhrs).done(function() {
            return callback();
        });
    });
});
